import React from "react";
// also exported from '@storybook/react' if you can deal with breaking changes in 6.1
import { FormConfiguration } from "../../FormConfiguration";
import { FormRuntime } from "../../FormRuntime";
import { PasswordFormControl } from "../Web/PasswordFormControl";
import { XStackContainer } from "../../Containers";
import { TextControlStyle } from "../../Utilities/FormDesignConstants";
import { StoryNode } from "../../../CommonUI/StoryBook/StoryData";

function getUI(): { form: FormConfiguration; control: PasswordFormControl } {
    let ui = new FormConfiguration();
    let container = new XStackContainer();

    ui.add(container);

    let textField = new PasswordFormControl();
    textField.label = "Text Field Label";
    textField.valueName = "value";
    textField.requiredOnAllOutcomes = false;
    container.add(textField);

    return { form: ui, control: textField };
}

export const PasswordBoxStories = [
    new StoryNode(
        () => {
            let ui = getUI();
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Password Box",
        "Default"
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.confirmPasswordRequired = true;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Password Box",
        "With Confirm"
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.confirmPasswordRequired = true;
            ui.control.overrideStyle = true;
            ui.control.style = TextControlStyle.OUTLINE;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Password Box",
        "Outline"
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.confirmPasswordRequired = true;
            ui.control.overrideStyle = true;
            ui.control.style = TextControlStyle.SHADED;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Password Box",
        "Shaded"
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.confirmPasswordRequired = true;
            ui.control.overrideStyle = true;
            ui.control.style = TextControlStyle.LABELED;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Password Box",
        "Labeled"
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.confirmPasswordRequired = true;
            ui.control.overrideStyle = true;
            ui.control.style = TextControlStyle.UNDERLINED;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Password Box",
        "Underlined"
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.confirmPasswordRequired = true;
            ui.control.overrideStyle = true;
            ui.control.style = TextControlStyle.UNDERLINED;
            ui.control.confirmPassword = "abc";
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Password Box",
        "Unmatched Confirm Password ?? - Review"
    ),
];
